"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[363],{

/***/ 8927:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "U": function() { return /* binding */ Collapse; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(9521);
;// CONCATENATED MODULE: ./src/themes/default/components/Collapse/styles.ts

function _templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 0;\n  opacity: 0;\n  overflow: hidden;\n\n  transition: height 0.3s ease, opacity 0.3s ease-in;\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}

const Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-21205f59-0"
})(_templateObject());

;// CONCATENATED MODULE: ./src/themes/default/components/Collapse/index.tsx



const Collapse = (param)=>{
    let { isOpen =false , children  } = param;
    const containerRef = (0,react.useRef)(null);
    const contentRef = (0,react.useRef)(null);
    (0,react.useEffect)(()=>{
        if (!containerRef.current || !contentRef.current) return;
        if (isOpen) {
            containerRef.current.style.height = "".concat(contentRef.current.clientHeight, "px");
            containerRef.current.style.opacity = "1";
        } else {
            containerRef.current.style.height = "0px";
            containerRef.current.style.opacity = "0";
        }
    }, [
        isOpen
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container, {
        ref: containerRef,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            ref: contentRef,
            children: children
        })
    });
};


/***/ }),

/***/ 8143:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Form_FormFieldSelect; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(3935);
// EXTERNAL MODULE: ./node_modules/react-icons/fi/index.esm.js
var index_esm = __webpack_require__(6893);
;// CONCATENATED MODULE: ./src/hooks/useIsomorphicLayoutEffect.ts

const useIsomorphicLayoutEffect =  true ? react.useLayoutEffect : 0;

;// CONCATENATED MODULE: ./src/hooks/useEventListener.ts
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */ /* eslint-disable @typescript-eslint/explicit-function-return-type */ /* eslint-disable consistent-return */ 

function useEventListener(eventName, handler, element) {
    // Create a ref that stores handler
    const savedHandler = (0,react.useRef)(handler);
    useIsomorphicLayoutEffect(()=>{
        savedHandler.current = handler;
    }, [
        handler
    ]);
    (0,react.useEffect)(()=>{
        // Define the listening target
        const targetElement = element || (element === null || element === void 0 ? void 0 : element.current) || window;
        if (!(targetElement && targetElement.addEventListener)) {
            return;
        }
        // Create event listener that calls handler function stored in ref
        const eventListener = (event)=>savedHandler.current(event);
        targetElement.addEventListener(eventName, eventListener);
        // Remove event listener on cleanup
        return ()=>{
            targetElement.removeEventListener(eventName, eventListener);
        };
    }, [
        eventName,
        element
    ]);
}

;// CONCATENATED MODULE: ./src/utils/withIsMounted.tsx
/* eslint-disable consistent-return */ 

function withIsMounted(FunctionalComponent) {
    return (props)=>{
        const [isMounted, setIsMounted] = (0,react.useState)(false);
        (0,react.useEffect)(()=>{
            setIsMounted(true);
            return ()=>{
                setIsMounted(false);
            };
        }, []);
        if (!isMounted) return null;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(FunctionalComponent, {
            ...props
        });
    };
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/polished/dist/polished.esm.js + 9 modules
var polished_esm = __webpack_require__(6637);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(9521);
;// CONCATENATED MODULE: ./src/themes/default/components/Form/Select/styles.ts

function _templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  width: 100%;\n  height: 36px;\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  cursor: pointer;\n  font-size: ",
        ";\n  line-height: 1em;\n  display: flex;\n\n  top: 50%;\n  transform: translateY(-50%);\n\n  right: 12px;\n\n  & svg {\n    stroke-width: 2;\n  }\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  cursor: pointer;\n  height: 100%;\n  width: 100%;\n  padding: ",
        " 14px;\n  padding-right: ",
        ";\n  border-radius: ",
        ";\n  font-size: ",
        ";\n  line-height: ",
        ";\n  border: 1px solid ",
        ";\n  background-color: ",
        ";\n  color: ",
        ";\n\n  transition: background-color 0.3s, border 0.3s;\n  will-change: background-color, border;\n\n  &:disabled {\n    background-color: ",
        ";\n  }\n"
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  background-color: ",
        ";\n  top: ",
        "px;\n  width: ",
        "px;\n  left: ",
        "px;\n  border: 1px solid ",
        ";\n  border-top: none;\n  overflow-x: auto;\n  border-bottom-left-radius: ",
        ";\n  border-bottom-right-radius: ",
        ";\n\n  transition: visibility 0.3s, opacity 0.3s, transform 0.3s;\n\n  transform: translateY(-5px);\n  opacity: 0;\n  visibility: hidden;\n\n  &.isOpen {\n    opacity: 1;\n    visibility: visible;\n    transform: translateY(0);\n  }\n\n  max-height: 200px;\n"
    ]);
    _templateObject3 = function() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  cursor: pointer;\n  font-size: ",
        ";\n  padding: ",
        " 14px;\n\n  background-color: ",
        ";\n\n  transition: background-color 0.3s;\n\n  border-top: 1px solid ",
        ";\n\n  &:hover {\n    background-color: ",
        ";\n  }\n\n  &.isActive {\n    color: ",
        ";\n    background-color: ",
        ";\n  }\n"
    ]);
    _templateObject4 = function() {
        return data;
    };
    return data;
}


const WrapperInput = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-f2cce891-0"
})(_templateObject());
const WrapperIcon = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-f2cce891-1"
})(_templateObject1(), (p)=>p.theme.font.xLarge);
const StyledInput = styled_components_browser_esm/* default.input.withConfig */.ZP.input.withConfig({
    componentId: "sc-f2cce891-2"
})(_templateObject2(), (p)=>p.theme.spacing.small, (p)=>"calc(12px + 12px + ".concat(p.theme.font.xLarge, ")"), (p)=>p.theme.borderRadius, (p)=>p.theme.font.small, (p)=>p.theme.spacing.medium, (p)=>p.theme.colors.border, (p)=>p.theme.input[p.color], (p)=>(0,polished_esm/* readableColor */.XV)((0,polished_esm/* darken */._j)(0.2, p.theme.input[p.color]), p.theme.colors.textDark, p.theme.colors.textLight), (p)=>p.theme.input.disabled);
const Dropdown = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-f2cce891-3"
})(_templateObject3(), (p)=>p.theme.colors.background, (param)=>{
    let { selectClientRect  } = param;
    return ((selectClientRect === null || selectClientRect === void 0 ? void 0 : selectClientRect.bottom) || 0) - 1;
}, (param)=>{
    let { selectClientRect  } = param;
    return selectClientRect === null || selectClientRect === void 0 ? void 0 : selectClientRect.width;
}, (param)=>{
    let { selectClientRect  } = param;
    return selectClientRect === null || selectClientRect === void 0 ? void 0 : selectClientRect.left;
}, (p)=>p.theme.colors.border, (p)=>p.theme.borderRadius, (p)=>p.theme.borderRadius);
const Option = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-f2cce891-4"
})(_templateObject4(), (p)=>p.theme.font.small, (p)=>p.theme.spacing.small, (p)=>p.theme.colors.background, (p)=>p.theme.colors.border, (p)=>p.theme.colors.backgroundHover, (p)=>(0,polished_esm/* readableColor */.XV)(p.theme.colors.primary, (0,polished_esm/* darken */._j)(0.5, p.theme.colors.primary), p.theme.colors.primary, false), (p)=>(0,polished_esm/* transparentize */.DZ)(0.95, p.theme.colors.primary));

;// CONCATENATED MODULE: ./src/themes/default/components/Form/Select/index.tsx







const Select = withIsMounted((param)=>{
    let { placeholder , disabled =false , color ="primary" , name , autoFocus =false , onChange , onBlur , value , type , as , maxLength , onKeyPress , options , getOptionLabel , getValueLabel  } = param;
    const selectRef = (0,react.useRef)(null);
    const [isOpen, setIsOpen] = (0,react.useState)(false);
    const [clientRect, setClientRect] = (0,react.useState)();
    const hasIcon = (0,react.useMemo)(()=>{
        return type === "password";
    }, [
        type
    ]);
    const handleClickSelect = (event)=>{
        if (event.target.id.includes("option")) return;
        setIsOpen((prev)=>!prev);
    };
    const handleClickOption = (option)=>{
        onChange === null || onChange === void 0 ? void 0 : onChange({
            target: {
                name,
                value: option
            }
        });
        setIsOpen(false);
    };
    const handleSetClientRect = ()=>{
        var ref;
        setClientRect((ref = selectRef.current) === null || ref === void 0 ? void 0 : ref.getBoundingClientRect());
    };
    (0,react.useEffect)(()=>{
        const closeDropdown = (event)=>{
            var ref;
            if (!((ref = selectRef.current) === null || ref === void 0 ? void 0 : ref.contains(event.target))) {
                setIsOpen(false);
            }
        };
        if (isOpen) {
            handleSetClientRect();
            document.addEventListener("mousedown", closeDropdown);
        } else {
            document.removeEventListener("mousedown", closeDropdown);
        }
        return ()=>{
            document.removeEventListener("mousedown", closeDropdown);
        };
    }, [
        isOpen
    ]);
    useEventListener("resize", handleSetClientRect);
    useEventListener("scroll", ()=>setIsOpen(false), document.getElementById("main-element"));
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(WrapperInput, {
        ref: selectRef,
        onClick: handleClickSelect,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledInput, {
                as: as,
                hasIcon: hasIcon,
                autoFocus: autoFocus,
                id: name,
                name: name,
                color: color,
                placeholder: placeholder,
                disabled: disabled,
                // onChange={onChange}
                onBlur: onBlur,
                onKeyPress: onKeyPress,
                value: getValueLabel(value),
                maxLength: maxLength,
                readOnly: true
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(WrapperIcon, {
                onClick: handleClickSelect,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* FiChevronDown */.bTu, {})
            }),
            /*#__PURE__*/ (0,react_dom.createPortal)(/*#__PURE__*/ (0,jsx_runtime.jsx)(Dropdown, {
                className: isOpen ? "isOpen" : "",
                selectClientRect: clientRect,
                children: options === null || options === void 0 ? void 0 : options.map((option)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(Option, {
                        id: "option-".concat(getValueLabel(option)),
                        onClick: ()=>handleClickOption(option),
                        className: value === option ? "isActive" : "",
                        children: getOptionLabel(option)
                    }, getValueLabel(option)))
            }), document.getElementById("portal-root"))
        ]
    });
});
/* harmony default export */ var Form_Select = (Select);

// EXTERNAL MODULE: ./src/themes/default/components/Collapse/index.tsx + 1 modules
var Collapse = __webpack_require__(8927);
;// CONCATENATED MODULE: ./src/themes/default/components/Form/FormFieldSelect/styles.ts

function styles_templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n      opacity: 0.6;\n    "
    ]);
    styles_templateObject = function() {
        return data;
    };
    return data;
}
function styles_templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  width: ",
        "%;\n\n  padding: ",
        ";\n\n  opacity: 1;\n\n  transition: opacity 0.3s;\n  will-change: opacity;\n\n  > span {\n    margin-bottom: ",
        ";\n  }\n\n  ",
        ";\n\n  & textarea {\n    line-height: ",
        ";\n  }\n"
    ]);
    styles_templateObject1 = function() {
        return data;
    };
    return data;
}
function styles_templateObject2() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: block;\n  padding-top: ",
        ";\n  color: ",
        ";\n"
    ]);
    styles_templateObject2 = function() {
        return data;
    };
    return data;
}

const Label = styled_components_browser_esm/* default.label.withConfig */.ZP.label.withConfig({
    componentId: "sc-ce67c7ed-0"
})(styles_templateObject1(), (p)=>p.width * 100, (p)=>p.theme.spacing.small, (p)=>p.theme.spacing.nano, (p)=>p.disabled && (0,styled_components_browser_esm/* css */.iv)(styles_templateObject()), (p)=>p.theme.font.xLarge);
const Error = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-ce67c7ed-1"
})(styles_templateObject2(), (p)=>p.theme.spacing.nano, (p)=>p.theme.colors.danger);

;// CONCATENATED MODULE: ./src/themes/default/components/Form/FormFieldSelect/index.tsx




const FormFieldSelect = (param)=>{
    let { label , width =1 , placeholder , disabled =false , name , autoFocus , onChange , onBlur , value , error , type , as , maxLength , onKeyPress , options , getOptionLabel , getValueLabel  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Label, {
        htmlFor: name,
        width: width,
        disabled: disabled,
        children: [
            label && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                children: label
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Form_Select, {
                as: as,
                autoFocus: autoFocus,
                name: name,
                disabled: disabled,
                placeholder: placeholder,
                onChange: onChange,
                onBlur: onBlur,
                value: value,
                type: type,
                maxLength: maxLength,
                onKeyPress: onKeyPress,
                options: options,
                getOptionLabel: getOptionLabel,
                getValueLabel: getValueLabel
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Collapse/* Collapse */.U, {
                isOpen: !!error,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Error, {
                    children: error
                })
            })
        ]
    });
};
/* harmony default export */ var Form_FormFieldSelect = (FormFieldSelect);


/***/ }),

/***/ 6326:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ components_TitleWithSort; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./src/themes/default/components/Form/FormFieldSelect/index.tsx + 6 modules
var FormFieldSelect = __webpack_require__(8143);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(9521);
;// CONCATENATED MODULE: ./src/themes/default/components/TitleWithSort/styles.ts

function _templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  font-size: ",
        ";\n  margin-bottom: ",
        ";\n  z-index: 1;\n\n  @media (max-width: 768px) {\n    flex-direction: column;\n    gap: ",
        ";\n  }\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: ",
        ";\n\n  label {\n    padding: 0;\n    width: 155px;\n  }\n\n  input {\n    color: ",
        ";\n  }\n\n  @media (max-width: 768px) {\n    flex-direction: column;\n    gap: ",
        ";\n  }\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: ",
        ";\n"
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-weight: 300;\n"
    ]);
    _templateObject3 = function() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  font-size: ",
        ";\n  text-transform: uppercase;\n\n  @media (max-width: 768px) {\n    font-size: ",
        ";\n  }\n"
    ]);
    _templateObject4 = function() {
        return data;
    };
    return data;
}
function _templateObject5() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-weight: 300;\n  white-space: nowrap;\n\n  strong {\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject5 = function() {
        return data;
    };
    return data;
}

const Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-915dcf6d-0"
})(_templateObject(), (p)=>p.theme.font.small, (p)=>p.theme.spacing.xLarge, (p)=>p.theme.spacing.large);
const WrapperRight = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-915dcf6d-1"
})(_templateObject1(), (p)=>p.theme.spacing.medium, (p)=>p.theme.colors.textSecondary, (p)=>p.theme.spacing.medium);
const WrapperLeft = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-915dcf6d-2"
})(_templateObject2(), (p)=>p.theme.spacing.quark);
const SupplementaryTitle = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-915dcf6d-3"
})(_templateObject3());
const Title = styled_components_browser_esm/* default.h1.withConfig */.ZP.h1.withConfig({
    componentId: "sc-915dcf6d-4"
})(_templateObject4(), (p)=>p.theme.colors.primary, (p)=>p.theme.font.xxLarge, (p)=>p.theme.font.xLarge);
const Subtitle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-915dcf6d-5"
})(_templateObject5(), (p)=>p.theme.colors.primary);

;// CONCATENATED MODULE: ./src/themes/default/components/TitleWithSort/index.tsx




const sortOptions = [
    {
        name: "Mais recentes",
        value: undefined
    },
    {
        name: "Menor pre\xe7o",
        value: "price-ascending"
    },
    {
        name: "Maior pre\xe7o",
        value: "price-descending"
    },
    {
        name: "A - Z",
        value: "name-ascending"
    },
    {
        name: "Z - A",
        value: "name-descending"
    }
];
const TitleWithSort = (param)=>{
    let { supplementaryTitle , title , subtitle , onChangeSortBy  } = param;
    const [sortValue, setSortValue] = (0,react.useState)(sortOptions[0]);
    const _subtitle = subtitle === null || subtitle === void 0 ? void 0 : subtitle.replace(/(\d+)/g, "<strong>$1</strong>");
    const handleChangeSort = (0,react.useCallback)((e)=>{
        setSortValue(e.target.value);
    }, []);
    (0,react.useEffect)(()=>{
        if (sortValue) {
            onChangeSortBy === null || onChangeSortBy === void 0 ? void 0 : onChangeSortBy(sortValue.value);
        }
    }, [
        onChangeSortBy,
        sortValue
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(WrapperLeft, {
                children: [
                    supplementaryTitle && /*#__PURE__*/ (0,jsx_runtime.jsx)(SupplementaryTitle, {
                        children: supplementaryTitle
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                        children: title
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(WrapperRight, {
                children: [
                    _subtitle && /*#__PURE__*/ (0,jsx_runtime.jsx)(Subtitle, {
                        dangerouslySetInnerHTML: {
                            __html: _subtitle
                        }
                    }),
                    onChangeSortBy && /*#__PURE__*/ (0,jsx_runtime.jsx)(FormFieldSelect/* default */.Z, {
                        name: "sort",
                        options: sortOptions,
                        value: sortValue,
                        onChange: handleChangeSort,
                        getOptionLabel: (opt)=>{
                            return opt === null || opt === void 0 ? void 0 : opt.name;
                        },
                        getValueLabel: (opt)=>{
                            return opt === null || opt === void 0 ? void 0 : opt.name;
                        }
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var components_TitleWithSort = (TitleWithSort);


/***/ })

}]);